import { useContext } from 'react'
import { NavLink } from 'react-router-dom'
import { TibiContext } from '../../context/ContextProvider'
import Button from '../Button/Button'
import DynamicFaIcon from '../DynamicFaIcon/DynamicFaIcon'

const NewOrderButton = () => {
    const { value }: any = useContext(TibiContext)
    const orderingDisabled = value?.user?.ordering_disabled === true || value?.user?.ordering_disabled === 'true'

    if (orderingDisabled) {
        return null
    }

    return (
        <Button>
            <NavLink to='/dashboard/new-order'>
                <DynamicFaIcon iconName='plus' className='mr-2' />
                Nieuwe opdracht
            </NavLink>
        </Button>
    )
}

export default NewOrderButton
